import { useEffect, useState } from 'react';
import axios from 'axios';
import { History, ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const money = (n) => `$${(Number(n) || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;

export const SavedW2List = ({ onCarryForward }) => {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/w2-saved`).then((r) => setRows(r.data.w2s || [])).catch(() => setRows([]));
  }, []);

  const shown = rows
    .filter((w) => `${w.employee_name} ${w.employer_name}`.toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => String(b.updated_at || '').localeCompare(String(a.updated_at || '')))
    .slice(0, 25);

  if (!rows.length) return null;
  return (
    <section className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-4" data-testid="w2studio-saved-list">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="text-xs font-bold uppercase tracking-wider text-zinc-400 flex items-center gap-2">
          <History className="w-4 h-4" /> Saved W-2s — carry one forward
        </p>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search name…"
          className="px-3 py-1.5 rounded-lg bg-zinc-950 border border-zinc-700 text-white text-xs w-44 focus:outline-none focus:border-emerald-500"
          data-testid="w2studio-saved-search"
        />
      </div>
      <div className="space-y-2 max-h-72 overflow-y-auto">
        {shown.map((w) => (
          <div key={w.id} className="flex items-center justify-between gap-3 p-3 rounded-lg bg-zinc-950 border border-zinc-800" data-testid={`w2studio-saved-${w.id}`}>
            <div className="min-w-0">
              <p className="text-sm text-white font-medium truncate">{w.employee_name || 'Employee'} <span className="text-zinc-500">· {w.employer_name || 'Employer'}</span></p>
              <p className="text-xs text-zinc-500">Tax year {w.tax_year} · Box 1 {money(w.payload?.box1_wages)}</p>
            </div>
            <button
              type="button"
              onClick={() => onCarryForward(w)}
              className="shrink-0 px-3 py-1.5 rounded-md border border-emerald-500/50 text-emerald-300 hover:bg-emerald-500/10 text-xs font-semibold flex items-center gap-1"
              data-testid={`w2studio-carry-${w.id}`}
            >
              Use for new year <ArrowRight className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};
